import { render, staticRenderFns } from "./template.vue?vue&type=template&id=674068a0&scoped=true&"
import script from "@/Components/Global/ModuleBox/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/ModuleBox/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/ModuleBox/style.scss?vue&type=style&index=0&id=674068a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674068a0",
  null
  
)

export default component.exports